/**
 * PrithviMart custom JavaScript
 * Clean version:
 * - Keeps Buy It Now working
 * - Keeps mobile search fix working
 * - Removes old window.scrollTo override that caused mobile freeze
 * - Ends the mobile Add to Cart loading state after successful adds
 */

/* =========================================================
   BUY IT NOW FUNCTIONALITY
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-action="buy-now"]');

    if (!button) return;

    event.preventDefault();

    const productId = button.getAttribute('data-product-id');

    if (!productId) {
      console.error('Product ID not found for Buy it Now button');
      return;
    }

    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: productId,
        quantity: 1,
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        return response.json();
      })
      .then(function () {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          })
        );

        window.location.href = '/checkout';
      })
      .catch(function (error) {
        console.error('Error adding product to cart:', error);

        button.textContent = originalText;
        button.disabled = false;

        alert('Sorry, there was an error adding the product to your cart. Please try again.');
      });
  });

  /* =========================================================
     CONSOLIDATED ADD TO CART DRAWER SUPPORT
     ========================================================= */

  if (!window.__pmUnifiedAddToCart) {
    window.__pmUnifiedAddToCart = true;

    let addToCartUnlockTimer = null;

    function pmHasActiveThemeOverlay() {
      const miniCart = document.getElementById('mini-cart');
      const searchWrapper = document.querySelector('.header__search-bar-wrapper');
      const searchResults = document.querySelector('.search-bar__results');
      const searchMenu = document.querySelector('.search-bar__menu-wrapper');
      const activeModal = document.querySelector('.modal[aria-hidden="false"], dialog[open], [role="dialog"][aria-hidden="false"]');

      return Boolean(
        (miniCart && miniCart.getAttribute('aria-hidden') === 'false') ||
          (searchWrapper && searchWrapper.classList.contains('is-fixed')) ||
          (searchResults && searchResults.getAttribute('aria-hidden') === 'false') ||
          (searchMenu && searchMenu.getAttribute('aria-hidden') === 'false') ||
          activeModal
      );
    }

    function pmUnlockCartUi() {
      clearTimeout(addToCartUnlockTimer);

      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      document.body.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

      const hasActiveOverlay = pmHasActiveThemeOverlay();

      document.documentElement.classList.remove('no-mobile-scroll', 'lock-all', 'lock-mobile', 'overflow-hidden');
      document.body.classList.remove('no-mobile-scroll', 'lock-all', 'lock-mobile', 'overflow-hidden');

      if (!hasActiveOverlay) {
        document.documentElement.classList.remove('is-locked');
        document.body.classList.remove('is-locked');

        ['overflow', 'overflowY', 'height', 'position', 'top', 'width', 'touchAction', 'pointerEvents'].forEach(function (prop) {
          document.documentElement.style[prop] = '';
          document.body.style[prop] = '';
        });
      }

      document.querySelectorAll('[aria-busy="true"]').forEach(function (element) {
        element.removeAttribute('aria-busy');
      });
    }

    function pmScheduleCartUnlock() {
      clearTimeout(addToCartUnlockTimer);
      addToCartUnlockTimer = setTimeout(pmUnlockCartUi, 2200);
    }

    function pmScheduleClosedCartUnlock() {
      setTimeout(pmUnlockCartUi, 80);
      setTimeout(pmUnlockCartUi, 350);
    }

    function pmIsMobileCartContext() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    function pmRefreshCartWithoutOpeningDrawer() {
      return updateAllCartCounts().finally(function () {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
              scrollToTop: false,
            },
          })
        );
      });
    }

    function pmGetCartQuantity(form) {
      const quantityInput = form.querySelector('[name="quantity"]');
      const quantity = quantityInput && quantityInput.value ? parseInt(quantityInput.value, 10) : 1;

      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }


    function pmIsEligibleAddToCart(button, form) {
      if (!button || !form) return false;
      if (!button.closest('.add-to-cart-form')) return false;
      if (button.closest('buy-button')) return false;
      if (button.closest('.shopify-payment-button')) return false;
      if (window.theme && window.theme.pageType === 'cart') return false;
      if (window.theme && window.theme.cartType === 'page') return false;

      return Boolean(
        button.closest('.product-item') ||
          button.closest('.add-to-cart-form') ||
          button.closest('[data-section-type="product-quick-view"]')
      );
    }

    function pmAjaxAddToCart(form) {
      return fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: new FormData(form),
      }).then(function (response) {
        if (response.ok) return response.json();

        return response.json().then(function (error) {
          throw new Error(error.description || error.message || 'Unable to add to cart');
        });
      });
    }

    document.addEventListener(
      'click',
      function (event) {
        const button = event.target.closest('.add-to-cart-form .add-to-cart-btn');
        const form = button ? button.closest('form[action*="/cart/add"]') : null;

        if (!pmIsEligibleAddToCart(button, form)) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (button.disabled || button.hasAttribute('disabled') || button.getAttribute('data-pm-atc-busy') === 'true') return;

        const originalText = button.textContent;
        const quantity = pmGetCartQuantity(form);

        button.setAttribute('data-pm-atc-busy', 'true');
        button.disabled = true;
        button.textContent = 'Adding...';

        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        pmScheduleCartUnlock();

        pmAjaxAddToCart(form)
          .then(function () {
            button.textContent = 'Added';

            if (pmIsMobileCartContext()) {
              return pmRefreshCartWithoutOpeningDrawer();
            } else {
              button.dispatchEvent(
                new CustomEvent('product:added', {
                  bubbles: true,
                  detail: {
                    button: button,
                    quantity: quantity,
                    productAdded: true,
                  },
                })
              );
            }
          })
          .catch(function (error) {
            console.error('Add to cart failed:', error);
            alert(error.message || 'Sorry, there was an error adding this product to your cart.');
          })
          .finally(function () {
            pmUnlockCartUi();

            setTimeout(function () {
              button.disabled = false;
              button.removeAttribute('data-pm-atc-busy');
              button.textContent = originalText;
              pmUnlockCartUi();
            }, 900);
          });
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        if (!event.target.closest('[data-action="toggle-mini-cart"]')) return;

        pmScheduleClosedCartUnlock();
      },
      true
    );

    const miniCart = document.getElementById('mini-cart');

    if (miniCart && window.MutationObserver) {
      new MutationObserver(function () {
        if (miniCart.getAttribute('aria-hidden') === 'true') {
          pmScheduleClosedCartUnlock();
        }
      }).observe(miniCart, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
      });
    }

    document.documentElement.addEventListener(
      'product:added',
      function (event) {
        if (!pmIsMobileCartContext()) return;
        if (event.detail && event.detail.productAdded === false) return;

        event.stopImmediatePropagation();
        pmRefreshCartWithoutOpeningDrawer();
        pmScheduleCartUnlock();
      },
      true
    );
  }
  /* =========================================================
     MOBILE SEARCH DRAWER SUPPORT
     ========================================================= */

  const searchBarWrapper = document.querySelector('.header__search-bar-wrapper');
  const searchInput = document.querySelector('.search-bar__input');

  function closeSearchDrawer() {
    if (!searchBarWrapper) return;

    searchBarWrapper.classList.remove('is-fixed');

    const searchBar = searchBarWrapper.querySelector('.search-bar');
    if (searchBar) {
      searchBar.classList.remove('is-expanded');
      searchBar.classList.remove('is-loading');
    }

    if (searchInput) {
      searchInput.blur();
    }

    document.documentElement.classList.remove('is-locked');
    document.body.classList.remove('no-mobile-scroll');

    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
    document.documentElement.style.position = '';
    document.documentElement.style.top = '';

    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';

    const searchResults = searchBarWrapper.querySelector('.search-bar__results');
    if (searchResults) {
      searchResults.setAttribute('aria-hidden', 'true');
    }

    const searchMenu = searchBarWrapper.querySelector('.search-bar__menu-wrapper');
    if (searchMenu) {
      searchMenu.setAttribute('aria-hidden', 'true');
    }
  }

  if (searchBarWrapper) {
    let isScrollingInsideDrawer = false;

    const searchInner = searchBarWrapper.querySelector('.search-bar__inner');
    const searchResults = searchBarWrapper.querySelector('.search-bar__results');

    if (searchInner) {
      searchInner.addEventListener(
        'scroll',
        function () {
          isScrollingInsideDrawer = true;
          setTimeout(function () {
            isScrollingInsideDrawer = false;
          }, 100);
        },
        { passive: true }
      );
    }

    if (searchResults) {
      searchResults.addEventListener(
        'scroll',
        function () {
          isScrollingInsideDrawer = true;
          setTimeout(function () {
            isScrollingInsideDrawer = false;
          }, 100);
        },
        { passive: true }
      );
    }

    window.addEventListener(
      'scroll',
      function () {
        if (searchBarWrapper.classList.contains('is-fixed') && !isScrollingInsideDrawer) {
          closeSearchDrawer();
        }
      },
      { passive: true }
    );

    const clearButton = document.querySelector('.search-bar__input-clear');
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        setTimeout(function () {
          closeSearchDrawer();
        }, 50);
      });
    }
  }

  /* =========================================================
     CART COUNT UPDATE
     ========================================================= */

  function updateAllCartCounts() {
    return fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document
          .querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, .cart-item-count, .cart__count')
          .forEach(function (element) {
            element.textContent = cart.item_count;
            element.classList.toggle('hidden', cart.item_count === 0);
          });

        return cart;
      })
      .catch(function (error) {
        console.error('Error updating cart count:', error);
      });
  }

  /* =========================================================
     CART PAGE MILESTONE PROGRESS BAR
     ========================================================= */

  function animateProgressBar() {
    const progressFill = document.querySelector('.cart__milestone-progress-fill');

    if (!progressFill) return;

    const inlineWidth = progressFill.getAttribute('style')
      ? progressFill.getAttribute('style').match(/width:\s*([\d.]+)%/)
      : null;

    const targetWidth = progressFill.getAttribute('data-width') || (inlineWidth ? inlineWidth[1] : null);

    if (!targetWidth) return;

    progressFill.style.width = '0%';
    progressFill.style.transition = 'none';

    progressFill.offsetHeight;

    requestAnimationFrame(function () {
      progressFill.style.transition = 'width 1s cubic-bezier(0.4, 0, 0.2, 1)';

      requestAnimationFrame(function () {
        progressFill.style.width = targetWidth + '%';
      });
    });
  }

  if (window.theme && theme.pageType === 'cart') {
    setTimeout(animateProgressBar, 50);
  }
});

/* =========================================================
   PRITHVIMART CLEAN MOBILE SEARCH FIX
   Fixes green bar overlap + unlocks scroll after close
   ========================================================= */

(function () {
  function pmIsMobile() {
    return window.matchMedia('(max-width: 640px)').matches;
  }

  function pmGetSearchWrapper() {
    return document.querySelector('.header__search-bar-wrapper');
  }

  function pmGetSearchInput() {
    return document.querySelector('.search-bar__input, input[name="q"]');
  }

  function pmHideGreenBar() {
    if (!pmIsMobile()) return;

    document.body.classList.add('pm-mobile-search-active');

    document.querySelectorAll('.pm-announcement-bar').forEach(function (bar) {
      bar.style.setProperty('display', 'none', 'important');
      bar.style.setProperty('visibility', 'hidden', 'important');
      bar.style.setProperty('height', '0', 'important');
      bar.style.setProperty('overflow', 'hidden', 'important');
      bar.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  function pmShowGreenBar() {
    document.body.classList.remove('pm-mobile-search-active');

    document.querySelectorAll('.pm-announcement-bar').forEach(function (bar) {
      bar.style.removeProperty('display');
      bar.style.removeProperty('visibility');
      bar.style.removeProperty('height');
      bar.style.removeProperty('overflow');
      bar.style.removeProperty('pointer-events');
    });
  }

  function pmUnlockScroll() {
    document.documentElement.classList.remove('is-locked');
    document.body.classList.remove('no-mobile-scroll');

    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
    document.documentElement.style.position = '';
    document.documentElement.style.top = '';

    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
  }

  function pmOpenSearchMode() {
    if (!pmIsMobile()) return;
    pmHideGreenBar();
    pmUnlockScroll();
    setTimeout(pmUnlockScroll, 60);
    setTimeout(pmUnlockScroll, 180);
  }

  function pmCloseSearchMode() {
    const searchWrapper = pmGetSearchWrapper();
    const searchInput = pmGetSearchInput();
    const searchBar = document.querySelector('.search-bar');
    const searchResults = document.querySelector('.search-bar__results');
    const searchMenu = document.querySelector('.search-bar__menu-wrapper');

    if (searchInput) {
      searchInput.blur();
    }

    if (searchWrapper) {
      searchWrapper.classList.remove('is-fixed');
      searchWrapper.classList.add('is-visible');
    }

    if (searchBar) {
      searchBar.classList.remove('is-expanded');
      searchBar.classList.remove('is-loading');
    }

    if (searchResults) {
      searchResults.setAttribute('aria-hidden', 'true');
    }

    if (searchMenu) {
      searchMenu.setAttribute('aria-hidden', 'true');
    }

    pmUnlockScroll();
    pmShowGreenBar();

    setTimeout(pmUnlockScroll, 100);
    setTimeout(pmUnlockScroll, 300);
    setTimeout(pmShowGreenBar, 300);
  }

  function pmGetSearchForm(target) {
    const form = target && target.closest ? target.closest('.header__search-bar-wrapper .search-bar') : null;
    return form || document.querySelector('.header__search-bar-wrapper .search-bar');
  }

  function pmBuildSearchUrl(form) {
    const searchInput = form ? form.querySelector('.search-bar__input, input[name="q"]') : pmGetSearchInput();
    const rawQuery = searchInput && searchInput.value ? searchInput.value.trim() : '';

    if (!rawQuery) return null;

    const productTypeSelect = form ? form.querySelector('#search-product-type') : document.getElementById('search-product-type');
    const productType = productTypeSelect && productTypeSelect.value ? productTypeSelect.value.trim() : '';
    const query = productType ? 'product_type:' + productType + ' AND ' + rawQuery : rawQuery;
    const searchUrl = window.routes && window.routes.searchUrl ? window.routes.searchUrl : '/search';
    const url = new URL(searchUrl, window.location.origin);

    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');

    return url.toString();
  }

  function pmSubmitSearch(event, form) {
    const searchUrl = pmBuildSearchUrl(form);

    if (!searchUrl) return false;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    pmUnlockScroll();
    pmShowGreenBar();
    window.location.assign(searchUrl);

    return true;
  }

  document.addEventListener(
    'submit',
    function (event) {
      const form = pmGetSearchForm(event.target);

      if (!form || event.target !== form) return;

      pmSubmitSearch(event, form);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter') return;
      if (!event.target.matches('.header__search-bar-wrapper .search-bar__input')) return;

      pmSubmitSearch(event, pmGetSearchForm(event.target));
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (event) {
      if (event.target.matches('.search-bar__input, input[name="q"]')) {
        setTimeout(pmOpenSearchMode, 50);
        setTimeout(pmOpenSearchMode, 150);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const clickedClear =
        event.target.closest('[data-action="clear-input"]') ||
        event.target.closest('.search-bar__input-clear');

      const clickedClose =
        event.target.closest('[data-action="unfix-search"]') ||
        event.target.closest('.search-bar__close-button');

      if (clickedClear || clickedClose) {
        setTimeout(pmCloseSearchMode, 80);
      }
    },
    true
  );

  document.addEventListener(
    'touchend',
    function (event) {
      const touchedClear =
        event.target.closest('[data-action="clear-input"]') ||
        event.target.closest('.search-bar__input-clear');

      const touchedClose =
        event.target.closest('[data-action="unfix-search"]') ||
        event.target.closest('.search-bar__close-button');

      if (touchedClear || touchedClose) {
        setTimeout(pmCloseSearchMode, 80);
      }
    },
    true
  );

  const searchWrapper = pmGetSearchWrapper();

  if (searchWrapper) {
    const observer = new MutationObserver(function () {
      if (searchWrapper.classList.contains('is-fixed')) {
        pmOpenSearchMode();
      }
    });

    observer.observe(searchWrapper, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  window.addEventListener('pageshow', function () {
    pmUnlockScroll();

    const searchWrapper = pmGetSearchWrapper();
    if (!searchWrapper || !searchWrapper.classList.contains('is-fixed')) {
      pmShowGreenBar();
    }
  });
})();

/* =========================================================
   PRITHVIMART PRODUCT CAROUSEL HEIGHT REPAIR
   Recalculates recommendation/recently viewed carousels after AJAX content settles
   ========================================================= */

(function () {
  function repairProductCarousels() {
    document
      .querySelectorAll(
        '[data-section-type="product-recommendations"] .product-list, [data-section-type="recently-viewed-products"] .product-list'
      )
      .forEach(function (list) {
        if (!list || !window.Flickity) return;

        var flkty = window.Flickity.data(list);
        if (flkty) {
          flkty.reloadCells();
          flkty.resize();
        }
      });
  }

  function scheduleProductCarouselRepair() {
    setTimeout(repairProductCarousels, 100);
    setTimeout(repairProductCarousels, 500);
    setTimeout(repairProductCarousels, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleProductCarouselRepair);
  } else {
    scheduleProductCarouselRepair();
  }

  window.addEventListener('load', scheduleProductCarouselRepair);
  document.addEventListener('shopify:section:load', scheduleProductCarouselRepair);

  var target = document.querySelector('[data-section-type="product-recommendations"], [data-section-type="recently-viewed-products"]');
  if (target && window.MutationObserver) {
    new MutationObserver(scheduleProductCarouselRepair).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();

/* =========================================================
   PRITHVIMART NATIVE TITLE BRAND FILTER
   Expands Shopify metafield filter values after the first six
   ========================================================= */

(function () {
  function syncTitleBrandGroup(group, expanded) {
    group.querySelectorAll('[data-pm-title-brand-extra]').forEach(function (item) {
      const input = item.querySelector('input[type="checkbox"]');
      item.hidden = !expanded && !(input && input.checked);
    });
  }

  function setupTitleBrandFilters(root) {
    (root || document).querySelectorAll('.pm-title-brand-native-filter').forEach(function (group) {
      const toggle = group.querySelector('[data-pm-title-brand-toggle]');

      if (!toggle) return;

      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      syncTitleBrandGroup(group, expanded);
    });
  }

  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('[data-pm-title-brand-toggle]');

    if (!toggle) return;

    const group = toggle.closest('.pm-title-brand-native-filter');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';

    if (!group) return;

    toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    toggle.textContent = expanded ? 'Show more' : 'Show less';
    syncTitleBrandGroup(group, !expanded);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupTitleBrandFilters(document);
    });
  } else {
    setupTitleBrandFilters(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupTitleBrandFilters(event.target);
  });
})();
